import {
  Box,
  Flex,
  Heading,
  SimpleGrid,
  Text,
  Link,
  Divider
} from '@chakra-ui/react';
import { useState } from 'react';
import Sidebar from '../components/Dashboard/Sidebar';
import { useAuth } from '../context/AuthContext';

const About = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed);
  const { user } = useAuth();

  return (
    <Flex direction="row" h="100vh">
      {/* Sidebar */}
      <Sidebar isCollapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <Box
        pl={sidebarCollapsed ? "60px" : "250px"}
        w="full"
        overflowY="auto"
        pb={8}
        transition="padding-left 0.2s ease"
      >
        <Box p={8}>
          <Heading size="xl" mb={2}>About the Quranic Data</Heading>
          <Text color="gray.600" mb={6}>
            This page provides information about the data sources used in this Quranic Data Hub,
            including Quranic text, translations, and audio recitations.
          </Text>

          <Divider mb={6} />

          <SimpleGrid spacing={8} maxW="800px">
            {/* Quranic Text */}
            <Box>
              <Heading size="md" mb={2}>Quranic Text</Heading>
              <Text color="gray.700" mb={2}>
                The Quranic Arabic text is based on the <strong>Uthmani script</strong>,
                ensuring accuracy and consistency with standard Mushaf formats.
              </Text>
              <Text color="gray.700">
                Data Source: <Link color="blue.500" href="https://quran.com" isExternal>Quran.com</Link> —
                a verified, carefully checked digital copy of the Quranic text.
              </Text>
              <Text color="gray.700">
                Font Source: <Link color="blue.500" href="https://fonts.qurancomplex.gov.sa/" isExternal>QuranComplex</Link> —
                <Link color="blue.500" href="https://fonts.qurancomplex.gov.sa/?fdc_download=https%3A%2F%2Ffonts.qurancomplex.gov.sa%2Fwp-content%2Fuploads%2F2022%2F12%2FUthmanTSVer1.ttf" isExternal>الخط السندي العادي</Link> - 
                a verified font from Saudi Arabia on Quranic text.
              </Text>
            </Box>

            {/* Translations */}
            <Box>
              <Heading size="md" mb={2}>Translations</Heading>
              <Text color="gray.700" mb={2}>
                Multiple translations are integrated to provide linguistic and interpretive diversity.
                The primary sources include:
              </Text>
              <Text color="gray.700">
                • <Link color="blue.500" href="https://quran.com" isExternal>Quran.com</Link> <br/>
                {/* • <Link color="blue.500" href="https://tanzil.net/trans/" isExternal>Tanzil Translations</Link> */}
              </Text>

              {/* Tambah translation */}
              <Text color="gray.700" pl={2}>
                <div>• English - Saheeh International</div>
                <div>• Malay - Abdullah Muhammad Basmeih</div>
              </Text>
              

            </Box>

            {/* Audio Data */}
            <Box>
              <Heading size="md" mb={2}>Audio Recitations</Heading>
              <Text color="gray.700" mb={2}>
                The audio files feature high-quality Quran recitations by various Qaris.
                These recordings are available under permissible licenses for non-commercial use.
              </Text>
              <Text color="gray.700">
                Source: <Link color="blue.500" href="https://quran.com" isExternal>Quran.com</Link> —
                a reliable source for Quranic audio with multiple reciters and formats.

                {/* Tambah Qari */}
              </Text>
            </Box>

            {/* Acknowledgement */}
            <Box>
              <Divider my={6} />
              <Heading size="md" mb={2}>Acknowledgment</Heading>
              <Text color="gray.700">
                We extend our gratitude to all open-source Quranic data providers
                and contributors for making these resources accessible to the community.
                The data is used solely for educational and research purposes.
              </Text>
            </Box>
          </SimpleGrid>
        </Box>
      </Box>
    </Flex>
  );
};

export default About;
